import React, {FC} from 'react';
import styled from 'styled-components';

import {DataEventContext} from '../../../../libs/shared/core/src/models/tracking/dataEventContexts';
import {DataEventTrackingProvider} from '../../../../libs/shared/core/src/services/tracking/dataEventTrackingProvider';
import {useAppSelector} from '../../../helpers/appReduxHelpers';
import {
  getHasIndividualTrainingAccess,
  getHasWebinarTrainingAccess,
} from '../../../store/data/company/companySelectors';
import {BottomBarIndividualTrainingButton} from './trial/bottomBarIndividualTrainingButton';
import {BottomBarPurchaseButton} from './trial/bottomBarPurchaseButton';
import {BottomBarTrialInfo} from './trial/bottomBarTrialInfo';
import {BottomBarWebinarTrainingButton} from './trial/bottomBarWebinarTrainingButton';

/*
 * Props.
 */

interface BottomBarProps {
  className?: string;
}

/*
 * Style.
 */

const StyledDiv = styled.div`
  border-top: 2px solid ${(p) => p.theme.appBackground};
  background-color: ${(p) => p.theme.background};

  padding: 10px 16px;
  display: flex;
  overflow: hidden;
  align-items: center;
  gap: 16px;
`;

const StyledActionsDiv = styled.div`
  display: flex;
  overflow: hidden;
  gap: 8px;
`;

/*
 * Component.
 */

const bottomBarDataContext: DataEventContext = Object.freeze({name: 'bottom_bar', payload: {}});

export const BottomBar: FC<BottomBarProps> = (props) => {
  const hasIndividualTrainingAccess = useAppSelector(getHasIndividualTrainingAccess);
  const hasWebinarTrainingAccess = useAppSelector(getHasWebinarTrainingAccess);

  const renderTrainingButton = () => {
    if (hasIndividualTrainingAccess) {
      return <BottomBarIndividualTrainingButton />;
    }

    if (hasWebinarTrainingAccess) {
      return <BottomBarWebinarTrainingButton />;
    }

    return null;
  };

  return (
    <DataEventTrackingProvider context={bottomBarDataContext}>
      <StyledDiv className={props.className}>
        <BottomBarTrialInfo />
        <StyledActionsDiv>
          <BottomBarPurchaseButton />
          {renderTrainingButton()}
        </StyledActionsDiv>
      </StyledDiv>
    </DataEventTrackingProvider>
  );
};
